import { Reveal } from "./motion";
import { ASSETS } from "./data";

const DiscoverSection = () => {
  return (
    <section data-testid="discover-section" className="relative bg-[#2A2E37] py-0">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 sm:px-8 md:grid-cols-2 md:gap-16">
        <Reveal>
          <img
            src={ASSETS.discover}
            alt="eurikaa posts from real places around the world"
            className="mx-auto w-full max-w-[560px] drop-shadow-2xl"
          />
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="font-headline text-4xl font-bold leading-[1.03] tracking-tight text-white sm:text-5xl md:text-6xl">
            Great Places Deserve To Be Experienced
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            Discover nearby hidden gems, events, landmarks, businesses, and experiences shared by
            your community. Every post leads to a real place, making it easy to explore and
            experience the world around you.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default DiscoverSection;
